import { Link } from 'react-router-dom';
import { Layout } from '../../components/layout';
import { Card } from './components';
import './Admin.styles.css';
import type { LinkTo } from './Admin.types.ts';
import { Breadcrumb } from 'antd';
import { getAdminLinks } from './helpers/getAdminLinks.ts';
import { BREADCRUMBS } from './Admin.constants.tsx';
import { useService } from './Admin.hooks.ts';
import { useEffect } from 'react';

export default function Admin() {
  const { entities } = useService();
  const linksToAdminPages: LinkTo[] = getAdminLinks(entities);

  useEffect(() => {
    document.title = 'Arbeitsgrundlagen Administration';
  }, []);

  return (
    <Layout rightSidebar={null} leftSidebar={null}>
      <div className="admin-page">
        <Breadcrumb className="breadcrumb" items={BREADCRUMBS} />
        <div className="cards">
          {linksToAdminPages.map((link: LinkTo) => (
            <Link key={link.id} to={link.path} className="card-link">
              <Card {...link} />
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  );
}
